<template>
    <div>
        <v-server-table v-if="!savedFilterId || (savedFilterId && savedFilter)" ref="safetyMeetingTable" url="/safety-meetings/list" :columns="columns" :options="options">

            <template slot="safety_meeting_id" slot-scope="props">
                <router-link :to="`/safety-meetings/view/${props.row.safety_meeting_id}`" title="View Safety Meeting" class="btn btn-sm btn-secondary">
                    View
                </router-link>
                <router-link  :to="`/safety-meetings/edit/${props.row.safety_meeting_id}`" title="Edit Safety Meeting" class="btn btn-sm btn-light">
                    <i class="fa fa-edit"></i> Edit
                </router-link>
            </template>

            <template slot="meeting_attendees" slot-scope="props">
                <span title="Click the + button to expand the meeting details and see the list of attendees.">
                    <template v-if="props.row.meeting_attendees">{{ props.row.meeting_attendees.length }}</template>
                </span>
            </template>

            <template slot="meeting_status" slot-scope="props">
                <label class="badge badge-success" v-if="props.row.meeting_status == 'Closed'">Closed</label>
                <label class="badge badge-danger" v-else>Open</label>
            </template>

            <router-link slot="meeting_date" slot-scope="props" :to="`/safety-meetings/view/${props.row.safety_meeting_id}`" title="View Safety Meeting">
                {{ props.row.meeting_date | moment("MM/DD/YYYY") }}
            </router-link>

            <template slot="DivisionName" slot-scope="props">
                {{ props.row.division_code }} - {{ props.row.DivisionName }}
            </template>

            <template slot="subcontractor_name" slot-scope="props">
                <router-link :to="`/subcontractors/view/${props.row.subcontractor_id}`" title="View Subcontractor" v-if="props.row.subcontractor_id">
                    {{ props.row.subcontractor_name }}
                </router-link>
            </template>

            <template slot="FirstName" slot-scope="props">
                <user-name :user="props.row" />
            </template>

            <template slot="child_row" slot-scope="props">
                <div class="form-group">
                    <label class="text-muted">Attendees:</label>
                    <span v-for="(att, key) in props.row.meeting_attendees">
                        <template v-if="key > 0">, </template>
                        <span>{{ att.name }}</span>
                    </span>
                </div>
                <div class="form-group">
                    <label class="text-muted">Meeting Notes:</label>
                    <div v-html="props.row.meeting_notes"></div>
                </div>

            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        props: ['timeFilter', 'savedFilterId'],

        data: function() {
            return {
                savedFilter: null,
                exportingTable: false,
                userTimezone: this.$store.state.user.timezone,
                columns: ['safety_meeting_id', 'meeting_attendees', 'meeting_status', 'meeting_date', 'DivisionName', 'JobsiteNumber', 'JobsiteName', 'FirstName', 'subcontractor_name'],
                options: {
                    headings: {
                        safety_meeting_id: 'Actions',
                        meeting_attendees: 'Attendees',
                        meeting_status: 'Status',
                        meeting_date: 'Date',
                        DivisionName: 'Division',
                        JobsiteName: 'Jobsite',
                        JobsiteNumber: 'Jobsite#',
                        FirstName: 'Creator',
                        subcontractor_name: 'Subcontractor',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'safety_meetings.meeting_date',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('safetyMeetingListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        if(this.savedFilter)
                        {
                            //Get the config
                            var tableConfig = JSON.parse(this.savedFilter.table_config);

                            data.limit = (tableConfig.limit ? tableConfig.limit : 25);
                            data.query = tableConfig.query;
                            data.orderBy = tableConfig.orderBy;
                            data.ascending = tableConfig.ascending;

                            data.filters = this.extractFilters();
                        }
                        else
                        {
                            //Set the filters
                            data.filters = {
                                'safety_meetings.meeting_date': this.timeFilter.toLowerCase(),
                            };
                        }

                        this.getPreviousData();

                        //Send it
                        return data;
                    },
                    uniqueKey: 'safety_meeting_id',
                },
            }
        },

        methods: {
            refresh: function() {
                this.$refs.safetyMeetingTable.refresh();
            },
            extractFilters: function() {
                let filters = {
                    'jobsite.DivisionId': [],
                };

                let table_filters = JSON.parse(this.savedFilter.table_filters);

                //Setters
                filters['safety_meetings.meeting_date'] = table_filters['safety_meetings.meeting_date'];
                filters['safety_meetings.meeting_status'] = table_filters['safety_meetings.meeting_status'];
                filters['safety_meetings.JobsiteId'] = table_filters['safety_meetings.JobsiteId'];
                filters['safety_meetings.is_subcontractor'] = table_filters['safety_meetings.is_subcontractor'];

                //Add the Divisions
                for (var i = 0; i < table_filters['jobsite.DivisionId'].length; i++)
                {
                    //Add each id
                    filters['jobsite.DivisionId'].push(table_filters['jobsite.DivisionId'][i]['id']);
                }

                //Send it
                return filters;
            },
            getPreviousData: function() {
                let filters = null;
                if(this.savedFilter)
                {
                    filters = this.extractFilters();
                    // Only these specific date filters have previous data
                    if (!filters['safety_meetings.meeting_date'] || (filters['safety_meetings.meeting_date'].split(':')[0] != 'rolling' && filters['safety_meetings.meeting_date'] != 'mtd' && filters['safety_meetings.meeting_date'] != 'ytd'))
                    {
                        this.$emit('prevSafetyMeetingListCount', undefined);
                        return;
                    }
                    filters['safety_meetings.meeting_date'] = 'prev_'+filters['safety_meetings.meeting_date'];
                }
                else
                {
                    //Set the filters
                    filters = {
                        'safety_meetings.meeting_date': 'prev_'+this.timeFilter.toLowerCase(),
                    };
                }

                this.$http.get('/safety-meetings/list', {'filters': filters})
                .then(response => {
                    this.$emit('prevSafetyMeetingListCount', response.data.count);
                })
                .catch(err => {

                })
                .then(() => {

                });
            },
        },

        mounted() {
            if (this.savedFilterId)
            {
                for(let i = 0; i < this.$store.state.user.filters.length; i++)
                {
                    if (this.$store.state.user.filters[i].id == this.savedFilterId)
                    {
                        this.savedFilter = this.$store.state.user.filters[i];
                        break;
                    }
                }
            }
        }

    }
</script>
